import React, { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { portalAPI } from '../../services/api';
import { notify } from '../../utils/notify';
import Modal from '../../components/Modal';
import { CONSENT_TEXT, CONSENT_VERSION } from './consentText';

// The location consent, asked before the first report that would carry a
// location. "I agree" stores the version and the language read; "Not now"
// sends the report without a location (it still counts, flagged).
const ConsentDialog = ({ onAccept, onDecline, onClose }) => {
  const { t, language } = useLanguage();
  const [shown, setShown] = useState(language === 'nl' ? 'nl' : 'en');
  const [busy, setBusy] = useState(false);

  const accept = async () => {
    try {
      setBusy(true);
      await portalAPI.acceptConsent({ version: CONSENT_VERSION, language: shown });
      await onAccept();
    } catch (error) {
      notify(error.response?.data?.message || t('Error saving your answer'), 'error');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal
      open
      title={t('Your location')}
      subtitle={t('Read this once before your first check-in')}
      onClose={onClose}
      busy={busy}
      size="md"
      footer={(
        <>
          <button type="button" className="btn btn--secondary" onClick={onDecline} disabled={busy}>{t('Not now: without location')}</button>
          <button type="button" className="btn btn--primary" onClick={accept} disabled={busy}>{t('I agree')}</button>
        </>
      )}
    >
      <div className="pt-consent" lang={shown}>
        {CONSENT_TEXT[shown].map((p) => <p key={p.slice(0, 24)}>{p}</p>)}
        <button type="button" className="pt-link" onClick={() => setShown(shown === 'nl' ? 'en' : 'nl')}>
          {shown === 'nl' ? 'Read in English' : 'Lees in het Nederlands'}
        </button>
        <p className="pt-muted">{t('Version {version}. You can withdraw it under Me.', { version: CONSENT_VERSION })}</p>
      </div>
    </Modal>
  );
};

export default ConsentDialog;
